import { gql } from '@apollo/client';

export default gql`
  query GetAcademyBilledCourse($courseId: String!) {
    course(courseId: $courseId)
      @rest(type: "CourseInvoice", path: "academy/courses/{args.courseId}") {
      _id
      periodStatus
      professor {
        _id
        name
        email
      }
      name
      invoices {
        _id
        course
        coursePeriodDateEnd
        coursePeriodDateInit
        paid
      }
    }
  }
`;
